import { Suspense, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import {
  addProjectTask,
  getProjectList,
  getProjectModule,
  getProjectSegment,
  getProjectSubModule,
  getProjectTaskList,
  TaskSummary,
} from "./Service/TaskService.js";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { Editor } from "primereact/editor";
import { AutoComplete } from "primereact/autocomplete";
import { TostMsg } from "../../../App.js";
import { getEmployeeList } from "../EmployeeList/Service/employeeService.js";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices.js";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding.js";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader.jsx";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import { useDispatch } from "react-redux";
import { setRecentProjectData } from "../../../Services/Redux/DataTransferToAnother.jsx";

const AddTask = ({
  isOpen,
  onClose,
  onSave,
  editTaskDetails,
  parentId,
  subTaskProjectId,
  taskCopy,
  detailPage,
  activityType,
}) => {
  const isDetailPageMode = Boolean(detailPage);
  const isEditMode = Boolean(editTaskDetails?.Id && !taskCopy && !isDetailPageMode);

  const [isLoading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const location = useLocation();
  const history = useHistory();

  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  const [employeDetails, setEmployeDetails] = useState([]);
  const [taskSegmentType, setTaskSegmentType] = useState([]);
  const [taskModuleType, setTaskModuleType] = useState([]);
  const [taskSeverityType, setTaskSeverityType] = useState([]);
  const [taskPriorityType, setTaskPriorityType] = useState([]);
  const [taskSubModuleType, setTaskSubModuleType] = useState([]);
  const [allProject, setAllProject] = useState([]);
  const [taskType, setTaskType] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [isProjectsLoading, setIsProjectsLoading] = useState(false);
  const [projectSummary, setProjectSummary] = useState([]);
  const [projectInputValue, setProjectInputValue] = useState("");
  const [selectedProjectObj, setSelectedProjectObj] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const projectJustSelectedRef = useRef(false);
  const projectDropdownClickedRef = useRef(false);
  const [parentInputValue, setParentInputValue] = useState("");
  const [selectedParentObj, setSelectedParentObj] = useState(null);
  const [filteredParentTasks, setFilteredParentTasks] = useState([]);
  const parentJustSelectedRef = useRef(false);
  const parentDropdownClickedRef = useRef(false);
  const [assignedInputValue, setAssignedInputValue] = useState("");
  const [selectedAssignedObj, setSelectedAssignedObj] = useState(null);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const assignedJustSelectedRef = useRef(false);
  const assignedDropdownClickedRef = useRef(false);
  const employeDetailsRef = useRef([]);
  const taskListRef = useRef([]);
  const allProjectRef = useRef([]);
  const dispatch = useDispatch();

  const initDoneRef = useRef(false);
  const staticDataLoadedRef = useRef(false);

  const setEmployeDetailsWithRef = (list) => {
    employeDetailsRef.current = list;
    setEmployeDetails(list);
  };
  const setTaskListWithRef = (list) => {
    taskListRef.current = list;
    setTaskList(list);
  };
  const setAllProjectWithRef = (list) => {
    allProjectRef.current = list;
    setAllProject(list);
  };

  const parseEstimatedHours = (value) => {
    const trimmed = String(value || "").trim();
    if (!trimmed) return "0.00";
    const hhmmMatch = trimmed.match(/^(\d+):([0-5]?\d)$/);
    if (hhmmMatch) {
      const hours = Number(hhmmMatch[1]);
      const minutes = Number(hhmmMatch[2]);
      return (hours + minutes / 60).toFixed(2);
    }
    const num = Number(trimmed);
    if (!Number.isFinite(num) || num < 0) return "0.00";
    return num.toFixed(2);
  };

  const taskLValidation = Yup.object().shape({
    TaskTitle: Yup.string().required("Task Title is required"),
    ProjectId: Yup.mixed()
      .required("Project is required")
      .test("not-empty", "Project is required", (val) => !!val),
    TaskTypeId: Yup.number().required("Type is required"),
    PriorityId: Yup.number().required("Priority is required"),
    SeverityId: Yup.number().required("Severity is required"),
    ModuleId: Yup.number().required("Module is required."),
    SubModuleId: Yup.number().required("Sub module is required."),
  });

  const initialValues = useMemo(() => {
    const projectId = editTaskDetails?.ProjectId || subTaskProjectId || "";
    const today = new Date().toISOString().slice(0, 10);
    let task_title;
    if (taskCopy) {
      task_title = `${editTaskDetails?.TaskTitle || ""}-Copy`;
    } else if (isDetailPageMode) {
      task_title = "";
    } else {
      task_title = editTaskDetails?.TaskTitle || "";
    }
    return {
      TaskTitle: task_title,
      ProjectId: projectId,
      SegmentId: editTaskDetails?.SegmentId || "",
      ModuleId: editTaskDetails?.ModuleId || "",
      SubModuleId: editTaskDetails?.SubModuleId || "",
      TaskTypeId: editTaskDetails?.TaskTypeId || "",
      PriorityId: editTaskDetails?.PriorityId || "",
      SeverityId: editTaskDetails?.SeverityId || "",
      AssignedToId: editTaskDetails?.AssignedToId?.toString() || "",
      StatusId: editTaskDetails?.StatusId || "",
      ReporterId: editTaskDetails?.ReporterId || "",
      EstimatedHours: parseEstimatedHours(editTaskDetails?.EstimatedHours || ""),
      DueDate: editTaskDetails?.DueDate?.split(" ")[0] || today,
      desc: isDetailPageMode ? "" : editTaskDetails?.TaskDescription || "",
      parentId: editTaskDetails?.ParentTaskId || parentId || 0,
    };
  }, [editTaskDetails, subTaskProjectId, parentId, isDetailPageMode]);

  const taskLForm = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: taskLValidation,
    onSubmit: async (values) => {
      setIsSaving(true);
      const body = {
        Id: isDetailPageMode
          ? 0
          : !taskCopy && editTaskDetails?.Id
            ? editTaskDetails.Id
            : 0,
        ProjectId: Number(values?.ProjectId),
        TaskTitle: values?.TaskTitle,
        TaskDescription: values?.desc || "",
        AssignedToId: values?.AssignedToId?.toString() || 0,
        ReporterId:
          editTaskDetails?.Id && (!taskCopy || isDetailPageMode)
            ? Number(values?.ReporterId) || 0
            : 0,
        TaskTypeId: Number(values?.TaskTypeId),
        PriorityId: Number(values?.PriorityId),
        SeverityId: Number(values?.SeverityId),
        StatusId:
          editTaskDetails?.Id && (!taskCopy || isDetailPageMode)
            ? Number(values?.StatusId) || 0
            : 0,
        ModuleId: Number(values?.ModuleId),
        SubModuleId: Number(values?.SubModuleId),
        SegmentId: Number(values?.SegmentId),
        DueDate: values?.DueDate,
        EstimatedHours: parseEstimatedHours(values?.EstimatedHours),
        Comment: "",
        SprintId: 0,
        ActualHours: 0,
        ParentTaskId: isDetailPageMode
          ? editTaskDetails?.Id
          : values?.parentId || 0,
      };

      try {
        await addProjectTask(body);        
        const selectedParentId = Number(values?.parentId || 0);
        const selectedParentGuid =
          selectedParentObj?.GUID ||
          taskList.find((task) => task.Id === selectedParentId)?.GUID;
        taskLForm.resetForm();
        if (selectedParentId === 0 && !editTaskDetails?.Id) {
          GetMasterSystemAlertList("Task_Add", 0);
        } else if (selectedParentId > 0 && !editTaskDetails?.Id) {
          GetMasterSystemAlertList("SubTask_Add", 0);
        } else {
          GetMasterSystemAlertList("Task_Update", 0);
        }

        setIsSaving(false);
        onClose("success");

        if (activityType === 0) {
          history.push(`/Project/Tasks/All`);
        } else if (activityType === 1) {
          if (editTaskDetails?.GUID) {
            history.push(`/Project/Task/Detail/${editTaskDetails.GUID}`);
          } else {
            history.push(`/Project/Tasks/All`);
          }
        } else if (activityType === 2) {
          if (selectedParentId > 0 && selectedParentGuid) {
            history.push(`/Project/Task/Detail/${selectedParentGuid}`);
          } else {
            history.push(`/Project/Tasks/All`);
          }
        } else {
          history.push(`/Project/Tasks/All`);
        }
        dispatch(setRecentProjectData('Task_Updated'));
      } catch (err) {
        toster.current.error(
          err?.response?.Data?.Message || "Something is wrong"
        );
        setIsSaving(false);
      } finally {
        setIsSaving(false);
      }
    },
  });

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name === message && type === 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  const loadStaticData = useCallback(
    async (isEdit) => {
      if (staticDataLoadedRef.current) return;
      staticDataLoadedRef.current = true;
      try {
        const [severityRes, priorityRes, typeRes] = await Promise.all([
          GetMasterTypeData({
            organisationId: userDetails?.OrgId,
            masterType: "TaskSeverity",
          }),
          GetMasterTypeData({
            organisationId: userDetails?.OrgId,
            masterType: "TaskPriority",
          }),
          GetMasterTypeData({
            organisationId: userDetails?.OrgId,
            masterType: "TaskType",
          }),
        ]);
        const severities = severityRes?.Data || [];
        const priorities = priorityRes?.Data || [];
        const types = typeRes?.Data || [];
        setTaskSeverityType(severities);
        setTaskPriorityType(priorities);
        setTaskType(types);
        if (!isEdit) {
          if (severities.length > 0)
            taskLForm.setFieldValue("SeverityId", severities[0].Id);
          if (priorities.length > 0)
            taskLForm.setFieldValue("PriorityId", priorities[0].Id);
          if (types.length > 0)
            taskLForm.setFieldValue("TaskTypeId", types[0].Id);
        }
      } catch (error) {
        toster.current.error(
          error?.data?.Data?.Message || "Something went wrong"
        );
      }
    },
    [userDetails?.OrgId]
  );

  async function fetchEmployeeIdData(projectId = 0) {
    if (!projectId) return;
    const params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
      ZoneId: 0,
      RegionId: 0,
      ProjectId: Number(projectId),
    };
    try {
      const employeesList = await getEmployeeList(params);
      setEmployeDetailsWithRef(employeesList?.Data || []);
    } catch (error) {
      toster.current.error(
        error?.data?.Data?.Message || "Something went wrong"
      );
    }
  }

  async function getMasterTaskModulesCategory(
    projectId = 0,
    isEdit = false,
    editModuleId = null
  ) {
    try {
      const data = await getProjectModule({ ProjectId: Number(projectId) });
      const modules = data?.Data || [];
      setTaskModuleType(modules);
      if (modules.length > 0 && !isEdit) {
        taskLForm.setFieldValue("ModuleId", modules[0].Id);
        getMasterTaskSubModuleCategory(projectId, modules[0].Id, false);
      }
      if (isEdit && editModuleId) {
        getMasterTaskSubModuleCategory(projectId, editModuleId, true);
      }
    } catch (error) {
      toster.current.error(
        error?.data?.Data?.Message || "Something went wrong"
      );
    }
  }

  async function getMasterTaskSubModuleCategory(
    projectId = 0,
    moduleId = 0,
    isEdit = false
  ) {
    try {
      const data = await getProjectSubModule({
        ProjectId: Number(projectId),
        ModuleId: Number(moduleId),
      });
      const subModules = data?.Data || [];
      setTaskSubModuleType(subModules);
      if (subModules.length > 0 && !isEdit) {
        taskLForm.setFieldValue("SubModuleId", subModules[0].Id);
      }
    } catch (error) {
      toster.current.error(
        error?.data?.Data?.Message || "Something went wrong"
      );
    }
  }

  async function getMasterTaskSegementCategory(projectId = 0, isEdit = false) {
    try {
      const data = await getProjectSegment({ ProjectId: Number(projectId) });
      const segments = data?.Data || [];
      setTaskSegmentType(segments);
      if (segments.length > 0 && !isEdit) {
        taskLForm.setFieldValue("SegmentId", segments[0].Id);
      }
    } catch (error) {
      toster.current.error(
        error?.data?.Data?.Message || "Something went wrong"
      );
    }
  }

  async function getProjectTask(projectId) {
    if (!projectId) return;
    const params = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      RaisedByEmpId: "",
      AssignedToId: "",
      TaskId: 0,
      StatusId: "",
      ModuleId: "",
      SubModuleId: "",
      PriorityId: "",
      SeverityId: "",
      Search: "",
      FilterStartDate: "",
      FilterEndDate: "",
      PageNumber: 1,
      PageSize: 10000000,
      IsDeleted: 0,
      SprintId: 0,
      TaskNumber: "",
      TaskGUID: "",
      ProjectId: projectId?.toString() || "",
      ParentTaskId: 0,
      TaskTypeId: "",
      SegmentId: "",
      SortBy: "",
      SortOrder: "ASC",
    };
    try {
      const data = await getProjectTaskList(params);
      const list = data?.Data?.OrgEmpTasks || [];
      setTaskListWithRef(list);
      setFilteredParentTasks(list.slice(0, 10));
    } catch (error) {
      toster.current.error(
        error?.data?.Data?.Message || "Something went wrong"
      );
    }
  }

  async function getTaskSummary() {
    try {
      const response = await TaskSummary({ DateRange: 0 });
      const recent = response?.Data?.RecentProjects || [];
      setProjectSummary(recent);
      return recent;
    } catch (error) {
      toster.current.error(
        error?.response?.Data?.Message || "Something went wrong"
      );
      return [];
    }
  }

  const resetAllState = useCallback(() => {
    initDoneRef.current = false;
    staticDataLoadedRef.current = false;

    setProjectInputValue("");
    setSelectedProjectObj(null);
    setFilteredProjects([]);

    setParentInputValue("");
    setSelectedParentObj(null);
    setFilteredParentTasks([]);

    setAssignedInputValue("");
    setSelectedAssignedObj(null);
    setFilteredEmployees([]);

    setEmployeDetailsWithRef([]);
    setTaskListWithRef([]);
    setAllProjectWithRef([]);
    setTaskModuleType([]);
    setTaskSubModuleType([]);
    setTaskSegmentType([]);
  }, []);

  // ─── Sync project display ─────────────────────────────────────────────────────
  useEffect(() => {
    if (!taskLForm.values.ProjectId || allProject.length === 0) return;
    const found = allProject.find(
      (p) => p.Id === Number(taskLForm.values.ProjectId)
    );
    if (found && selectedProjectObj?.Id !== found.Id) {
      setSelectedProjectObj(found);
      setProjectInputValue(found.Name || "");
    }
  }, [allProject, taskLForm.values.ProjectId]);

  // ─── Sync parent task display ─────────────────────────────────────────────────
  useEffect(() => {
    if (!taskLForm.values.parentId || taskList.length === 0) return;
    const found = taskList.find(
      (t) => t.Id === Number(taskLForm.values.parentId)
    );
    if (found && selectedParentObj?.Id !== found.Id) {
      setSelectedParentObj(found);
      setParentInputValue(found.TaskTitle || "");
      taskLForm.setFieldValue("parentId", found.Id);
    }
  }, [taskList, taskLForm.values.parentId]);

  // ─── Sync assigned-to display ─────────────────────────────────────────────────
  useEffect(() => {
    if (!employeDetails?.length || !taskLForm.values.AssignedToId) return;
    const found = employeDetails.find(
      (emp) => String(emp.EmpId) === String(taskLForm.values.AssignedToId)
    );
    if (found && selectedAssignedObj?.EmpId !== found.EmpId) {
      setSelectedAssignedObj(found);
      setAssignedInputValue(found.FullName || "");
    }
  }, [employeDetails, taskLForm.values.AssignedToId]);

  // ─── Main open/close effect ───────────────────────────────────────────────────
  useEffect(() => {
    if (!isOpen) {
      taskLForm.resetForm();
      resetAllState();
      return;
    }

    if (initDoneRef.current) return;
    initDoneRef.current = true;

    const currentIsEdit = !!(
      editTaskDetails?.Id &&
      !taskCopy &&
      !isDetailPageMode
    );
    loadStaticData(currentIsEdit);

    const initForm = async () => {
      try {
        setIsProjectsLoading(true);
        const res = await getProjectList({ Id: 0, PageNumber: 1, PageSize: 1000 });
        const projectList = res?.Data?.ProjectList || [];
        setAllProjectWithRef(projectList);
        setFilteredProjects(projectList.slice(0, 10));

        let projectId = editTaskDetails?.ProjectId || subTaskProjectId;
        if (!projectId) {
          const recentProjects = await getTaskSummary();
          projectId =
            Number(recentProjects?.[0]?.EntityId || 0) || undefined;
        }

        if (projectId) {
          const proj = projectList.find(
            (p) => p.Id === Number(projectId)
          );
          if (proj) {
            setSelectedProjectObj(proj);
            setProjectInputValue(proj.Name || "");
            taskLForm.setFieldValue("ProjectId", proj.Id);
            await Promise.all([
              fetchEmployeeIdData(proj.Id),
              getProjectTask(proj.Id),
              getMasterTaskModulesCategory(
                proj.Id,
                true,
                editTaskDetails?.ModuleId
              ),
              getMasterTaskSegementCategory(proj.Id, true),
            ]);
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        setIsProjectsLoading(false);
      }
    };

    initForm();
  }, [isOpen]);

  // ─── Edit mode: pre-fill parent task ─────────────────────────────────────────
  useEffect(() => {
    const parentTaskId =
      editTaskDetails?.ParentTaskId || editTaskDetails?.parentId;
    if (!isDetailPageMode && parentTaskId && taskList.length > 0) {
      const found = taskList.find((t) => t.Id == parentTaskId);
      if (found) {
        setSelectedParentObj(found);
        setParentInputValue(found.TaskTitle || "");
        taskLForm.setFieldValue("parentId", found.Id);
        setFilteredParentTasks((prev) =>
          [found, ...prev.filter((t) => t.Id !== found.Id)].slice(0, 10)
        );
      }
    }
  }, [taskList, editTaskDetails?.ParentTaskId, editTaskDetails?.parentId, isDetailPageMode]);

  const showFieldError = (field) =>
    !!taskLForm.errors[field] &&
    (taskLForm.touched[field] || taskLForm.submitCount > 0);

  const employeeOptionTemplate = (option) => {
    if (!option) return null;
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName || "User"}
          src={option?.ProfileImage || "/images/placeholder_profile.png"}
          width="32"
        />
        <span>{option?.FullName || "Unknown"}</span>
      </div>
    );
  };

  const headerTemplate = (
    <span className="ql-formats0">
      <select className="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <select className="ql-font">
        <option selected></option>
        <option value="serif"></option>
        <option value="monospace"></option>
      </select>
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      <select className="ql-color"></select>
      <select className="ql-background"></select>
      <button className="ql-list" value="ordered"></button>
      <button className="ql-list" value="bullet"></button>
      <select className="ql-align"></select>
      <button className="ql-link"></button>
      <button className="ql-code-block"></button>
      <button className="ql-clean"></button>
    </span>
  );

  if (!isOpen) return null;

  // ─── Project dropdown helpers ─────────────────────────────────────────────────
  const handleProjectSelect = (proj) => {
    projectJustSelectedRef.current = true;
    setSelectedProjectObj(proj);
    setProjectInputValue(proj.Name || "");
    taskLForm.setFieldValue("ProjectId", proj.Id);

    taskLForm.setFieldValue("ModuleId", "");
    taskLForm.setFieldValue("SubModuleId", "");
    taskLForm.setFieldValue("SegmentId", "");
    taskLForm.setFieldValue("AssignedToId", "");
    setTaskModuleType([]);
    setTaskSubModuleType([]);
    setTaskSegmentType([]);
    setSelectedAssignedObj(null);
    setAssignedInputValue("");

    setSelectedParentObj(null);
    setParentInputValue("");
    taskLForm.setFieldValue("parentId", "");
    setFilteredParentTasks([]);

    setIsProjectsLoading(true);

    (async () => {
      try {
        await Promise.all([
          getMasterTaskModulesCategory(proj.Id, false),
          getMasterTaskSegementCategory(proj.Id, false),
          getProjectTask(proj.Id),
          fetchEmployeeIdData(proj.Id),
        ]);
      } finally {
        setIsProjectsLoading(false);
        setTimeout(() => {
          projectJustSelectedRef.current = false;
        }, 500);
      }
    })();
  };

  const handleProjectClear = () => {
    setSelectedProjectObj(null);
    setProjectInputValue("");
    taskLForm.setFieldValue("ProjectId", "");
    setTaskModuleType([]);
    setTaskSubModuleType([]);
    setTaskSegmentType([]);
    setFilteredProjects([]);
    projectDropdownClickedRef.current = false;
    setSelectedParentObj(null);
    setParentInputValue("");
    taskLForm.setFieldValue("parentId", "");
    setFilteredParentTasks([]);
    setSelectedAssignedObj(null);
    setAssignedInputValue("");
    taskLForm.setFieldValue("AssignedToId", "");
    setFilteredEmployees([]);
  };

  // ─── Parent Task dropdown helpers ─────────────────────────────────────────────
  const handleParentSelect = (task) => {
    parentJustSelectedRef.current = true;
    setSelectedParentObj(task);
    setParentInputValue(task.TaskTitle || "");
    taskLForm.setFieldValue("parentId", task.Id);
    setTimeout(() => {
      parentJustSelectedRef.current = false;
    }, 500);
  };

  const handleParentClear = () => {
    setSelectedParentObj(null);
    setParentInputValue("");
    taskLForm.setFieldValue("parentId", "");
    setFilteredParentTasks([]);
  };

  // ─── Assigned To dropdown helpers ─────────────────────────────────────────────
  const handleAssignedSelect = (emp) => {
    assignedJustSelectedRef.current = true;
    setSelectedAssignedObj(emp);
    setAssignedInputValue(emp.FullName || "");
    taskLForm.setFieldValue("AssignedToId", emp.EmpId || "");
    setTimeout(() => {
      assignedJustSelectedRef.current = false;
    }, 500);
  };

  const handleAssignedClear = () => {
    setSelectedAssignedObj(null);
    setAssignedInputValue("");
    taskLForm.setFieldValue("AssignedToId", "");
    setFilteredEmployees([]);
    assignedDropdownClickedRef.current = false;
  };

  // ─── Suggestion helpers ───────────────────────────────────────────────────────
  const getProjectSuggestions = (query = "") => {
    const list = allProjectRef.current;
    if (!list || list.length === 0) return [];
    const q = query.trim().toLowerCase();
    if (!q) return list.slice(0, 10);
    return list.filter((p) => p.Name?.toLowerCase().includes(q)).slice(0, 10);
  };

  const getParentSuggestions = (query = "") => {
    const list = taskListRef.current;
    if (!list || list.length === 0) return [];
    const q = query.trim().toLowerCase();
    if (!q) return list.slice(0, 10);
    return list.filter((t) => t.TaskTitle?.toLowerCase().includes(q)).slice(0, 10);
  };

  const getEmployeeSuggestions = (query = "") => {
    const list = employeDetailsRef.current;
    if (!list || list.length === 0) return [];
    const q = query.trim().toLowerCase();
    if (!q) return list.slice(0, 10);
    return list.filter((e) => e.FullName?.toLowerCase().includes(q)).slice(0, 10);
  };

  return (
    <div className="mo-tm">
      <div className="mb wide">
        <div className="mh">
          <div
            style={{
              width: "28px",
              height: "28px",
              background: "var(--brand-soft)",
              borderRadius: "7px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--brand)",
            }}
          >
            <i className="fa-solid fa-list-check"></i>
          </div>
          <h5 id="taskModalTitle">Task Details</h5>
          <button
            type="button"
            className="btn btn-ghost btn-icon mla"
            onClick={() => onClose("close")}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <form onSubmit={taskLForm.handleSubmit}>
          <div className="mbody">
            <input type="hidden" id="editTaskId" />
            <input type="hidden" id="isEditing" value="0" />

            {/* Task Title */}
            <div style={{ marginBottom: "16px", position: "relative" }}>
              <label
                className="fl"
                style={{ fontSize: "12px", marginBottom: "6px" }}
              >
                Task Title <i className="inValidError">*</i>
              </label>
              {isProjectsLoading && (
                <div
                  className="login-loader"
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "12px",
                    transform: "translateY(-50%)",
                  }}
                ></div>
              )}
              <input
                name="TaskTitle"
                className="fc"
                style={{ fontSize: "16px", fontWeight: 600, padding: "12px 14px" }}
                value={taskLForm.values.TaskTitle}
                onChange={taskLForm.handleChange}
                onBlur={taskLForm.handleBlur}
                disabled={isProjectsLoading}
                placeholder={isProjectsLoading ? "Loading..." : ""}
              />
              {showFieldError("TaskTitle") && (
                <small className="invalid-feedback">
                  {taskLForm.errors.TaskTitle}
                </small>
              )}
            </div>

            {/* Description */}
            <div style={{ marginBottom: "14px" }}>
              <label className="fl">Description</label>
              <Editor
                name="shortDesc"
                value={taskLForm.values.desc}
                onTextChange={(e) =>
                  taskLForm.setFieldValue("desc", e.htmlValue)
                }
                headerTemplate={headerTemplate}
                style={{ height: "150px" }}
              />
            </div>

            {/* Project & Segment */}
            <div className="task-form-group">
              <div className="frow fc2" style={{ marginBottom: "0" }}>
                <div className="position-relative project-search-icon">
                  <label className="fl">
                    Project <i className="inValidError">*</i>
                  </label>
                  {isProjectsLoading && (
                    <div
                      className="login-loader"
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "28px",
                        transform: "translate(-50%, -50%)",
                      }}
                    ></div>
                  )}

                  {/* ── PROJECT AUTOCOMPLETE ── */}
                  <AutoComplete
                    inputClassName="fs"
                    name="ProjectId"
                    field="Name"
                    dropdownMode="current"
                    dropdown={true}
                    className={showFieldError("ProjectId") ? "is-invalid" : ""}
                    value={projectInputValue}
                    suggestions={filteredProjects}
                    completeMethod={(e) => {
                      const results = getProjectSuggestions(e.query);
                      setFilteredProjects(results);
                    }}
                    onFocus={() => {
                      const results = getProjectSuggestions(projectInputValue);
                      if (results.length > 0) setFilteredProjects(results);
                    }}
                    onDropdownClick={() => {
                      projectDropdownClickedRef.current = true;
                      const results = getProjectSuggestions(projectInputValue);
                      setFilteredProjects(results);
                      setTimeout(() => {
                        projectDropdownClickedRef.current = false;
                      }, 500);
                    }}
                    onChange={(e) => {
                      const val = e.value;
                      if (val && typeof val === "object") return;
                      const typed = val ?? "";
                      setProjectInputValue(typed);
                      if (projectJustSelectedRef.current) return;
                      if (selectedProjectObj) {
                        if (
                          !typed ||
                          !selectedProjectObj.Name?.toLowerCase().startsWith(
                            typed.toLowerCase()
                          )
                        ) {
                          handleProjectClear();
                          setProjectInputValue(typed);
                        }
                      }
                      if (!typed) {
                        setTaskModuleType([]);
                        setTaskSubModuleType([]);
                        setTaskSegmentType([]);
                        setFilteredProjects([]);
                      }
                    }}
                    onSelect={(e) => {
                      projectJustSelectedRef.current = true;  // ← set BEFORE handler
                      handleProjectSelect(e.value);
                    }}
                    onBlur={() => {
                      if (projectJustSelectedRef.current || projectDropdownClickedRef.current) return;
                      setTimeout(() => {
                        if (projectJustSelectedRef.current || projectDropdownClickedRef.current) return;
                        if (selectedProjectObj) {
                          setProjectInputValue(selectedProjectObj.Name || "");
                        } else {
                          setProjectInputValue("");
                          taskLForm.setFieldValue("ProjectId", "");
                        }
                        setFilteredProjects([]);
                      }, 500);
                    }}
                    placeholder="Search Project"
                    disabled={Boolean(subTaskProjectId && !isDetailPageMode)}
                  />
                  {showFieldError("ProjectId") && (
                    <small className="invalid-feedback d-block">
                      {taskLForm.errors.ProjectId}
                    </small>
                  )}
                </div>

                <div>
                  <label className="fl">Segment</label>
                  <select
                    name="SegmentId"
                    className="fs"
                    value={taskLForm.values.SegmentId}
                    disabled={!taskLForm.values.ProjectId}
                    onChange={taskLForm.handleChange}
                    onBlur={taskLForm.handleBlur}
                  >
                    <option value="">
                      {!taskLForm.values.ProjectId
                        ? "Select Project First"
                        : "All Segment"}
                    </option>
                    {taskSegmentType?.map((segment) => (
                      <option key={segment.Id} value={segment.Id}>
                        {segment.Name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Parent Task & Module */}
            <div className="task-form-group">
              <div className="frow fc3" style={{ marginBottom: "0" }}>
                <div
                  style={{ position: "relative" }}
                  className="project-search-icon"
                >
                  <label className="fl">Parent Task</label>

                  {/* ── PARENT TASK AUTOCOMPLETE ── */}
                  <AutoComplete
                    inputClassName="fs"
                    name="parentId"
                    field="TaskTitle"
                    dataKey="Id"
                    dropdownMode="current"
                    value={parentInputValue}
                    suggestions={filteredParentTasks}
                    completeMethod={(e) => {
                      const results = getParentSuggestions(e.query);
                      setFilteredParentTasks(results);
                    }}
                    onFocus={() => {
                      const results = getParentSuggestions(parentInputValue);
                      if (results.length > 0) setFilteredParentTasks(results);
                    }}
                    onDropdownClick={() => {
                      parentDropdownClickedRef.current = true;
                      const results = getParentSuggestions(parentInputValue);
                      setFilteredParentTasks(results);
                      setTimeout(() => {
                        parentDropdownClickedRef.current = false;
                      }, 500);
                    }}
                    emptyMessage="No tasks found"
                    onChange={(e) => {
                      const val = e.value;
                      if (val && typeof val === "object") return;
                      const typed = val ?? "";
                      setParentInputValue(typed);
                      if (selectedParentObj) {
                        if (
                          !typed ||
                          !selectedParentObj.TaskTitle?.toLowerCase().startsWith(
                            typed.toLowerCase()
                          )
                        ) {
                          setSelectedParentObj(null);
                          taskLForm.setFieldValue("parentId", "");
                        }
                      }
                      if (!typed) setFilteredParentTasks([]);
                    }}
                    onSelect={(e) => {
                      parentJustSelectedRef.current = true;  // ← set BEFORE handler
                      handleParentSelect(e.value);
                    }}
                    onBlur={() => {
                      if (parentJustSelectedRef.current || parentDropdownClickedRef.current) return;
                      setTimeout(() => {
                        if (parentJustSelectedRef.current || parentDropdownClickedRef.current) return;
                        if (selectedParentObj) {
                          setParentInputValue(selectedParentObj.TaskTitle || "");
                        } else {
                          setParentInputValue("");
                          taskLForm.setFieldValue("parentId", "");
                        }
                        setFilteredParentTasks([]);
                      }, 500);
                    }}
                    itemTemplate={(suggestion) => (
                      <div>{suggestion?.TaskTitle}</div>
                    )}
                    placeholder="Search Parent Task"
                    disabled={
                      !(taskLForm.values.ProjectId || selectedProjectObj?.Id) ||
                      (parentId > 0 && !isDetailPageMode)
                    }
                  />
                </div>

                <div>
                  <label className="fl">
                    Module (Category) <i className="inValidError">*</i>
                  </label>
                  <select
                    name="ModuleId"
                    className="fs"
                    value={taskLForm.values.ModuleId}
                    disabled={!taskLForm.values.ProjectId}
                    onBlur={taskLForm.handleBlur}
                    onChange={(e) => {
                      const val = e.target.value;
                      taskLForm.setFieldValue("ModuleId", val);
                      taskLForm.setFieldValue("SubModuleId", "");
                      setTaskSubModuleType([]);
                      if (val)
                        getMasterTaskSubModuleCategory(
                          taskLForm.values.ProjectId,
                          val,
                          false
                        );
                    }}
                  >
                    <option value="">
                      {!taskLForm.values.ProjectId
                        ? "Select Project First"
                        : "All Category"}
                    </option>
                    {taskModuleType?.map((m) => (
                      <option key={m.Id} value={m.Id}>
                        {m.Name}
                      </option>
                    ))}
                  </select>
                  {showFieldError("ModuleId") && (
                    <small className="invalid-feedback">
                      {taskLForm.errors.ModuleId}
                    </small>
                  )}
                </div>

                <div>
                  <label className="fl">
                    Sub Module <i className="inValidError">*</i>
                  </label>
                  <select
                    name="SubModuleId"
                    className="fs"
                    value={taskLForm.values.SubModuleId}
                    disabled={!taskLForm.values.ModuleId}
                    onChange={taskLForm.handleChange}
                    onBlur={taskLForm.handleBlur}
                  >
                    <option value="">
                      {!taskLForm.values.ModuleId
                        ? "Select Module First"
                        : "All Sub-Category"}
                    </option>
                    {taskSubModuleType?.map((s) => (
                      <option key={s.Id} value={s.Id}>
                        {s.Name}
                      </option>
                    ))}
                  </select>
                  {showFieldError("SubModuleId") && (
                    <small className="invalid-feedback">
                      {taskLForm.errors.SubModuleId}
                    </small>
                  )}
                </div>
              </div>
            </div>

            {/* Classification */}
            <div className="task-form-group">
              <div className="frow fc3" style={{ marginBottom: "0" }}>
                <div>
                  <label className="fl">
                    Type <i className="inValidError">*</i>
                  </label>
                  <select
                    name="TaskTypeId"
                    className="fs"
                    value={taskLForm.values.TaskTypeId}
                    onChange={taskLForm.handleChange}
                    onBlur={taskLForm.handleBlur}
                  >
                    <option value="">Select Type</option>
                    {taskType.map((t) => (
                      <option value={t?.Id} key={t?.Id}>
                        {t?.Name}
                      </option>
                    ))}
                  </select>
                  {showFieldError("TaskTypeId") && (
                    <small className="invalid-feedback">
                      {taskLForm.errors.TaskTypeId}
                    </small>
                  )}
                </div>
                <div>
                  <label className="fl">
                    Priority <i className="inValidError">*</i>
                  </label>
                  <select
                    name="PriorityId"
                    className="fs"
                    value={taskLForm.values.PriorityId}
                    onChange={taskLForm.handleChange}
                    onBlur={taskLForm.handleBlur}
                  >
                    <option value="">Select Priority</option>
                    {taskPriorityType?.map((p) => (
                      <option key={p.Id} value={p.Id}>
                        {p.Name}
                      </option>
                    ))}
                  </select>
                  {showFieldError("PriorityId") && (
                    <small className="invalid-feedback">
                      {taskLForm.errors.PriorityId}
                    </small>
                  )}
                </div>
                <div>
                  <label className="fl">
                    Severity <i className="inValidError">*</i>
                  </label>
                  <select
                    name="SeverityId"
                    className="fs"
                    value={taskLForm.values.SeverityId}
                    onChange={taskLForm.handleChange}
                    onBlur={taskLForm.handleBlur}
                  >
                    <option value="">Select Severity</option>
                    {taskSeverityType?.map((s) => (
                      <option key={s.Id} value={s.Id}>
                        {s.Name}
                      </option>
                    ))}
                  </select>
                  {showFieldError("SeverityId") && (
                    <small className="invalid-feedback">
                      {taskLForm.errors.SeverityId}
                    </small>
                  )}
                </div>
              </div>
            </div>

            {/* Assignment */}
            <div className="task-form-group">
              <div
                style={{
                  fontSize: "10.5px",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: ".5px",
                  color: "var(--muted)",
                  marginBottom: "10px",
                }}
              >
                Assignment
              </div>
              <div
                className="frow fc3 project-search-icon"
                style={{ marginBottom: "0" }}
              >
                <div>
                  <label className="fl">Assigned To</label>

                  {/* ── ASSIGNED TO AUTOCOMPLETE ── */}
                  <AutoComplete
                    name="AssignedToId"
                    value={assignedInputValue}
                    suggestions={filteredEmployees}
                    dropdownMode="current"
                    dropdown={true}
                    field="FullName"
                    completeMethod={(e) => {
                      const results = getEmployeeSuggestions(e.query);
                      setFilteredEmployees(results);
                    }}
                    onFocus={() => {
                      const results = getEmployeeSuggestions(assignedInputValue);
                      if (results.length > 0) setFilteredEmployees(results);
                    }}
                    onDropdownClick={() => {
                      assignedDropdownClickedRef.current = true;
                      const results = getEmployeeSuggestions(assignedInputValue);
                      setFilteredEmployees(results);
                      setTimeout(() => {
                        assignedDropdownClickedRef.current = false;
                      }, 500);
                    }}
                    onChange={(e) => {
                      const val = e.value;
                      if (val && typeof val === "object") return;
                      const typed = val ?? "";
                      setAssignedInputValue(typed);
                      if (selectedAssignedObj) {
                        if (
                          !typed ||
                          !selectedAssignedObj.FullName?.toLowerCase().startsWith(
                            typed.toLowerCase()
                          )
                        ) {
                          setSelectedAssignedObj(null);
                          taskLForm.setFieldValue("AssignedToId", "");
                        }
                      }
                      if (!typed) setFilteredEmployees([]);
                    }}
                    onSelect={(e) => {
                      assignedJustSelectedRef.current = true;  // ← set BEFORE handler
                      handleAssignedSelect(e.value);
                    }}
                    onBlur={() => {
                      if (assignedJustSelectedRef.current || assignedDropdownClickedRef.current) return;
                      setTimeout(() => {
                        if (assignedJustSelectedRef.current || assignedDropdownClickedRef.current) return;
                        if (selectedAssignedObj) {
                          setAssignedInputValue(selectedAssignedObj.FullName || "");
                        } else {
                          setAssignedInputValue("");
                          taskLForm.setFieldValue("AssignedToId", "");
                        }
                        setFilteredEmployees([]);
                      }, 500);
                    }}
                    placeholder={
                      !(taskLForm.values.ProjectId || selectedProjectObj?.Id)
                        ? "Select Project First"
                        : "Search Assigned To"
                    }
                    disabled={!taskLForm.values.ProjectId}
                    itemTemplate={employeeOptionTemplate}
                    inputClassName="fs"
                  />
                </div>

                <div>
                  <label className="fl">Estimation (Hrs:min)</label>
                  <input
                    type="text"
                    name="EstimatedHours"
                    className="fc"
                    placeholder="0.00"
                    value={taskLForm.values.EstimatedHours}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (
                        /^(\d{0,3}(?::\d{0,2})?|\d{0,3}(?:\.\d{0,2})?)$/.test(
                          value
                        )
                      ) {
                        taskLForm.setFieldValue("EstimatedHours", value);
                      }
                    }}
                    onBlur={(e) => {
                      taskLForm.handleBlur(e);
                      taskLForm.setFieldValue(
                        "EstimatedHours",
                        parseEstimatedHours(e.target.value)
                      );
                    }}
                  />
                </div>

                <div>
                  <label className="fl">Due Date</label>
                  <input
                    className="fc"
                    type="date"
                    name="DueDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    value={taskLForm.values.DueDate}
                    onChange={taskLForm.handleChange}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mfoot">
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => onClose("close")}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-brand">
              <i className="fa-solid fa-check"></i>{" "}
              <span id="taskSaveTxt">Save Task</span>
            </button>
          </div>
        </form>
      </div>

      {isSaving ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : null}
    </div>
  );
};

export default AddTask;